import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePlaySession } from '@/play/contexts/PlaySessionContext';

interface RequireJuniorSessionProps {
  children: React.ReactNode;
}

export function RequireJuniorSession({ children }: RequireJuniorSessionProps) {
  const { hasSession, isAuthLoading } = usePlaySession();

  if (isAuthLoading) {
    return (
      <div className="min-h-[40vh] flex items-center justify-center">
        <p className="text-sm font-bold animate-pulse" style={{ color: '#A855F7' }}>
          Cargando tu cuenta…
        </p>
      </div>
    );
  }

  if (!hasSession) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}

export default RequireJuniorSession;
